<div class="cerrarModalOtp">
  <i class="fa-regular fa-circle-xmark close-button" (click)="closeModal()"></i>
</div>
<div class="modalOtp">
  <mat-horizontal-stepper linear #stepper>
      <!-- Paso 1: Verificación del Número de Contacto -->
      <mat-step [stepControl]="firstFormGroup">
        <form [formGroup]="firstFormGroup">
          <h3>Verifica tu número de contacto</h3>
          <p>Te enviaremos un código de verificación por WhatsApp al número de celular.</p>
          <mat-form-field>
            <mat-label>
              Número de teléfono
            </mat-label>
            <input matInput inputmode="numeric" [placeholder]="firstFormGroup.get('phoneNumber')?.value || 'Número de teléfono'" formControlName="phoneNumber">
            <mat-icon matSuffix *ngIf="isFieldValidFirst('phoneNumber')">
              <img src="\assets\img\Form/checkFields.svg" alt="CheckField" style="margin-right: 20px; width: 26px;">
            </mat-icon>
          </mat-form-field>    
          <p *ngIf="showAttemptExceededMessage" style="color: red;">
            Has superado el número de intentos permitidos.<br>
            Comunícate con uno de nuestros asesores:<br>
            <a href="https://api.whatsapp.com/send?phone=573105909238&text=%C2%A1Hola%21+Tengo+problemas+con+el+c%C3%B3digo+de+verificaci%C3%B3n%2C+me+gustar%C3%ADa+contactarme+con+un+asesor" 
               target="_blank" style="color: green; text-decoration: underline;">
              <i class="fa-brands fa-whatsapp"></i> Aquí
            </a>.
          </p>  
          <p *ngIf="errorMessage && errorMessage==='Numero de intentos superados. Intenta de nuevo.' && !showAttemptExceededMessage" style="color: red;">{{ errorMessage }}</p>
          <div>    
            <div style="display: flex; justify-content: center; align-items: center;">
              <button 
                mat-raised-button 
                class="btnOtpWhatsapp" 
                (click)="sendCodeWhatsapp(stepper)"
                *ngIf="!isLoading">
                Enviar Código WhatsApp
                <img src="\assets\img\Header-Footer\wp.svg" alt="Icono de WhatsApp" style="margin-left: 10px; width: 18px; margin-top: -3px;">
              </button>
            </div>   
            <mat-spinner 
                *ngIf="isLoading" 
                diameter="24" 
                style="display: block; margin: 0 auto;">
            </mat-spinner>
          </div>                    
        </form>
      </mat-step>
    
      <!-- Paso 2: Ingreso del Código de Verificación -->
      <mat-step [stepControl]="secondFormGroup">
        <form [formGroup]="secondFormGroup">
          <h3>Ingresa el código de verificación</h3>
          <p>Introduce el código recibido por mensaje de texto</p>
          <div class="otp-inputs">
            <mat-form-field class="otp-field">
              <input
                matInput
                maxlength="4" 
                formControlName="otp0"
                (input)="handleInput($event, 0)"
                (keydown)="handleBackspace($event, 0)"
                inputmode="numeric"
                id="otp0"
                #otpInput
              />
            </mat-form-field>
            <mat-form-field class="otp-field">
              <input
                matInput
                maxlength="1"
                formControlName="otp1"
                (input)="handleInput($event, 1)"
                (keydown)="handleBackspace($event, 1)"
                inputmode="numeric"
                id="otp1"
                #otpInput
              />
            </mat-form-field>
            <mat-form-field class="otp-field">
              <input
                matInput
                maxlength="1"
                formControlName="otp2"
                (input)="handleInput($event, 2)"
                (keydown)="handleBackspace($event, 2)"
                inputmode="numeric"
                id="otp2"
                #otpInput
              />
            </mat-form-field>
            <mat-form-field class="otp-field">
              <input
                matInput
                maxlength="1"
                formControlName="otp3"
                (input)="handleInput($event, 3)"
                (keydown)="handleBackspace($event, 3)"
                inputmode="numeric"
                id="otp3"
                #otpInput
              />
            </mat-form-field>
          </div>            
      
          <!-- Mostrar error solo si no se ha superado el número de intentos -->
          <mat-error *ngIf="attemptedVerification && secondFormGroup.invalid && !showAttemptExceededMessage" style="font-size: 16px;">
            Código no cumple con las características: 4 dígitos y valor numérico
          </mat-error>
      
          <!-- Mostrar el contador solo si el tiempo restante es mayor a 0 y no se ha superado el número de intentos -->
          <p *ngIf="timeLeft > 0 && !showAttemptExceededMessage">Tiempo restante: {{ minutes }}:{{ seconds | number: '2.0' }}</p>
      
          <!-- Mostrar mensaje de error solo si no se ha superado el número de intentos -->
          <p *ngIf="errorMessage && !showAttemptExceededMessage" style="color: red;">{{ errorMessage }}</p>
      

          <!-- Mostrar mensaje de intentos superados -->
          <p *ngIf="showAttemptExceededMessage" style="color: red;">
            Has superado el número de intentos permitidos.<br>
            Comunícate con uno de nuestros asesores:<br>
            <a href="https://api.whatsapp.com/send?phone=573105909238&text=%C2%A1Hola%21+Tengo+algunas+dudas+con+respecto+a+la+cotizaci%C3%B3n+de+mi+seguro+y+me+gustar%C3%ADa+contactarme+con+un+asesor+para+poder+aclararlas" 
               target="_blank" style="color: green; text-decoration: underline;">
              <i class="fa-brands fa-whatsapp"></i> Aquí
            </a>.
          </p>
          <button mat-raised-button class="btnOtp" (click)="verifyCode(stepper)" [disabled]="isLoading">
            Verificar
          </button>
        </form>
      </mat-step>              
  </mat-horizontal-stepper>
</div>  

